export default {
    hasResponseSwitch(responsesIds: number[], currentId: number, method: string = 'next'): boolean {
        const current_index = responsesIds.indexOf(currentId);
        if (current_index === -1) {
            return false;
        }

        const index = method === 'next' ? current_index + 1 : current_index - 1;

        if (!responsesIds[index]) {
            return false;
        }
        return true;
    }
}